import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {Sound} from '../../../shared/scripts/Sound'
import {uiManager} from '../EntryHomepage'
import {SocketLobbySend} from '../../../shared/scripts/socket/SocketLobbySend'
import {ViewPopupRankedGameDescription} from '../../../shared/scripts/ui_popup/ViewPopupRankedGameDescription.ts'
import {KeyBindController, ShortcutLocation} from '../../../shared/scripts/KeyBindController'
import {setElementInnerHTML} from '../../../shared/scripts/ui_utils/DomUtils'
import {TranslationObject} from '@colonist/i18n'
import {createGloballyExclusiveHandler, throttleUserAction} from '../../../shared/scripts/ui_utils/ClientUtils'
import {DiscordInstance} from '../discord/DiscordInstance.ts'
import {RoomType} from '@colonist/lobby-types'
import {ClientUserState} from '../../../shared/scripts/ClientUserState.ts'

export class UIMatchmakingSelectMatchPopupView {
    private readonly container: HTMLDivElement
    private readonly content: HTMLDivElement
    private readonly optionBot: HTMLDivElement
    private readonly optionUnranked4Player: HTMLDivElement
    private readonly optionRanked4Player: HTMLDivElement
    private readonly optionUnranked1v1: HTMLDivElement
    private readonly optionRanked1v1: HTMLDivElement
    private readonly optionRankedCitiesAndKnights: HTMLDivElement
    private readonly optionBeginnerMode: HTMLDivElement
    private readonly optionCreateCustomGame: HTMLDivElement
    private readonly optionEasyBots: HTMLDivElement
    private readonly optionMediumBots: HTMLDivElement
    private readonly optionHardBots: HTMLDivElement
    private readonly rankedGameDescriptionBtnClassic: HTMLDivElement
    private readonly rankedGameDescriptionBtn1v1: HTMLDivElement
    private readonly rankedGameDescriptionBtnCitiesAndKnights: HTMLDivElement
    private readonly popupTitle: HTMLParagraphElement
    readonly rankedStateUnrankedBase: HTMLParagraphElement
    readonly rankedStateUnranked1v1: HTMLParagraphElement
    readonly rankedStateRankedBase: HTMLParagraphElement
    readonly rankedStateRanked1v1: HTMLParagraphElement
    readonly rankedStateCitiesAndKnights: HTMLParagraphElement

    private readonly optionUnranked4PlayerTitle: HTMLParagraphElement
    private readonly optionUnranked1v1Title: HTMLParagraphElement

    constructor() {
        this.container = document.getElementById('matchmaking-selectmatch-popup') as HTMLDivElement
        this.popupTitle = document.getElementById('matchmaking-selectmatch-popup-title') as HTMLParagraphElement
        this.content = document.getElementById('matchmaking-selectmatch-popup-content') as HTMLDivElement
        this.optionBot = document.getElementById('matchmaking_popup_item_bot') as HTMLDivElement
        this.optionBeginnerMode = document.getElementById('matchmaking_popup_item_beginnerMode') as HTMLDivElement
        this.optionUnranked4Player = document.getElementById('matchmaking_popup_item_classic') as HTMLDivElement
        this.optionRanked4Player = document.getElementById('matchmaking_popup_item_ranked_classic') as HTMLDivElement
        this.optionRankedCitiesAndKnights = document.getElementById('matchmaking_popup_item_ranked_cities_and_knights') as HTMLDivElement
        this.optionUnranked1v1 = document.getElementById('matchmaking_popup_item_1v1') as HTMLDivElement
        this.optionCreateCustomGame = document.getElementById('matchmaking_popup_item_create_custom_game') as HTMLDivElement
        this.optionRanked1v1 = document.getElementById('matchmaking_popup_item_ranked_1v1') as HTMLDivElement
        this.optionEasyBots = document.getElementById('matchmaking_popup_item_easy_bots') as HTMLDivElement
        this.optionMediumBots = document.getElementById('matchmaking_popup_item_medium_bots') as HTMLDivElement
        this.optionHardBots = document.getElementById('matchmaking_popup_item_hard_bots') as HTMLDivElement
        this.rankedStateUnrankedBase = document.getElementById('matchmaking_popup_item_unranked_classic_rankedstate') as HTMLParagraphElement
        this.rankedStateUnranked1v1 = document.getElementById('matchmaking_popup_item_unranked_1v1_rankedstate') as HTMLParagraphElement
        this.rankedStateRanked1v1 = document.getElementById('matchmaking_popup_item_ranked_1v1_rankedstate') as HTMLParagraphElement
        this.rankedStateRankedBase = document.getElementById('matchmaking_popup_item_ranked_classic_rankedstate') as HTMLParagraphElement
        this.rankedStateCitiesAndKnights = document.getElementById('matchmaking_popup_item_ranked_cities_and_knights_rankedstate') as HTMLParagraphElement
        this.rankedGameDescriptionBtn1v1 = document.getElementById('ranked_game_description_btn_1v1') as HTMLDivElement
        this.rankedGameDescriptionBtnClassic = document.getElementById('ranked_game_description_btn_classic') as HTMLDivElement
        this.rankedGameDescriptionBtnCitiesAndKnights = document.getElementById('ranked_game_description_btn_cities_and_knights') as HTMLDivElement

        this.optionUnranked4PlayerTitle = document.getElementById('unranked-4player-title') as HTMLParagraphElement
        this.optionUnranked1v1Title = document.getElementById('unranked-1v1-title') as HTMLParagraphElement

        this.optionBot.onclick = throttleUserAction(() => {
            Sound.playSound(Sound.SoundType.Click)
            this.showAllBotOptions()
        })

        this.optionEasyBots.onclick = createGloballyExclusiveHandler(async() => {
            Sound.playSound(Sound.SoundType.Click)
            await SocketLobbySend.clickedStartEasyBotGame()
            this.hide()
        })

        this.optionMediumBots.onclick = createGloballyExclusiveHandler(async() => {
            Sound.playSound(Sound.SoundType.Click)
            await SocketLobbySend.clickedStartMediumBotGame()
            this.hide()
        })

        this.optionHardBots.onclick = createGloballyExclusiveHandler(async() => {
            Sound.playSound(Sound.SoundType.Click)
            await SocketLobbySend.clickedStartHardBotGame()
            this.hide()
        })

        this.optionBeginnerMode.onclick = createGloballyExclusiveHandler(async() => {
            Sound.playSound(Sound.SoundType.Click)
            await SocketLobbySend.continueCampaignMode()
            this.hide()
        })

        this.optionUnranked4Player.onclick = createGloballyExclusiveHandler(async() => {
            Sound.playSound(Sound.SoundType.Click)
            await ClientUserState.requireUser()
            uiManager.matchmakingController.sendFindGameMessageToServer([MatchmakingMatchTypes.UnrankedClassic4P])
        })

        this.optionRanked4Player.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            uiManager.matchmakingController.sendFindGameMessageToServer([MatchmakingMatchTypes.RankedClassic4P])
        }

        this.optionUnranked1v1.onclick = createGloballyExclusiveHandler(async() => {
            Sound.playSound(Sound.SoundType.Click)
            await ClientUserState.requireUser()
            uiManager.matchmakingController.sendFindGameMessageToServer([MatchmakingMatchTypes.UnrankedClassic1v1])
        })

        this.optionRankedCitiesAndKnights.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            uiManager.matchmakingController.sendFindGameMessageToServer([MatchmakingMatchTypes.RankedCitiesAndKnights4P])
        }

        this.optionRanked1v1.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            uiManager.matchmakingController.sendFindGameMessageToServer([MatchmakingMatchTypes.RankedClassic1v1])
        }

        this.optionCreateCustomGame.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            const channelId = DiscordInstance.getDiscordInstance().voiceChannelId
            SocketLobbySend.clickedJoinChannelRoomOrGame(channelId, RoomType.DiscordActivity)
            this.hide()
        }

        this.rankedGameDescriptionBtn1v1.onclick = (mouseEvent: MouseEvent) => {
            UIMatchmakingSelectMatchPopupView.showRankedGameDescription(mouseEvent)
        }

        this.rankedGameDescriptionBtnClassic.onclick = (mouseEvent: MouseEvent) => {
            UIMatchmakingSelectMatchPopupView.showRankedGameDescription(mouseEvent)
        }

        this.rankedGameDescriptionBtnCitiesAndKnights.onclick = (mouseEvent: MouseEvent) => {
            UIMatchmakingSelectMatchPopupView.showRankedGameDescription(mouseEvent)
        }

        this.setCancel()
        this.setKeyBind()
    }

    private static showRankedGameDescription(mouseEvent: MouseEvent) {
        mouseEvent.stopPropagation()
        mouseEvent.preventDefault()
        new ViewPopupRankedGameDescription()
    }

    private setCancel() {
        window.addEventListener('click', createGloballyExclusiveHandler((event: PointerEvent) => {
            if(event.target == this.container) {
                this.hide()
            }
        }))
    }

    private setKeyBind() {
        KeyBindController.bindKey('Escape', createGloballyExclusiveHandler<void>(() => this.hide()), () => this.isVisible(), ShortcutLocation.InLobby)
    }

    private isVisible(): boolean {
        return this.container.style.display == 'block'
    }

    removeOptionRanked1v1() {
        this.optionRanked1v1.style.display = 'none'
    }

    removeOptionRankedBase() {
        this.optionRanked4Player.style.display = 'none'
    }

    removeOptionRankedCitiesAndKnights() {
        this.optionRankedCitiesAndKnights.style.display = 'none'
    }

    private removeOptionUnranked4Player() {
        this.optionUnranked4Player.style.display = 'none'
    }

    private removeOptionUnranked1Player() {
        this.optionUnranked1v1.style.display = 'none'
    }

    private showOptionRanked1v1() {
        this.optionRanked1v1.style.display = 'flex'
    }

    private showOptionBot() {
        this.optionBot.style.display = 'flex'
    }

    private showOptionBeginnerMode() {
        this.optionBeginnerMode.style.display = 'flex'
    }

    private showOptionCreateAdvancedMode() {
        this.optionCreateCustomGame.style.display = 'flex'
    }

    private showOptionRankedBase() {
        this.optionRanked4Player.style.display = 'flex'
    }

    private showOptionRankedCitiesAndKnights() {
        this.optionRankedCitiesAndKnights.style.display = 'flex'
    }

    private showOptionUnranked4Player() {
        this.optionUnranked4Player.style.display = 'flex'
    }

    private showOptionUnranked1Player() {
        this.optionUnranked1v1.style.display = 'flex'
    }

    private removeOptionBeginnerMode() {
        this.optionBeginnerMode.style.display = 'none'
    }

    private removeOptionCreateAdvancedMode() {
        this.optionCreateCustomGame.style.display = 'none'
    }

    private removeOptionBot() {
        this.optionBot.style.display = 'none'
    }

    private showOptionEasyBots() {
        this.optionEasyBots.style.display = 'flex'
    }

    private showOptionMediumBots() {
        this.optionMediumBots.style.display = 'flex'
    }

    private showOptionHardBots() {
        this.optionHardBots.style.display = 'flex'
    }

    private removeOptionEasyBots() {
        this.optionEasyBots.style.display = 'none'
    }

    private removeOptionMediumBots() {
        this.optionMediumBots.style.display = 'none'
    }

    private removeOptionHardBots() {
        this.optionHardBots.style.display = 'none'
    }

    hideRankedOptions() {
        this.hideOptions()
        this.showOptionUnranked1Player()
        this.showOptionUnranked4Player()
        this.content.style.width = '40%'

        const unranked4PTitleText: TranslationObject = {key: 'strings:homePage.ranked.4Player'}
        const unranked1v1TitleText: TranslationObject = {key: 'strings:homePage.ranked.1v1'}
        setElementInnerHTML(this.optionUnranked4PlayerTitle, unranked4PTitleText)
        setElementInnerHTML(this.optionUnranked1v1Title, unranked1v1TitleText)
    }

    showRankedOptions() {
        this.hideOptions()
        this.showOptionUnranked1Player()
        this.showOptionUnranked4Player()
        this.showOptionRanked1v1()
        this.showOptionRankedBase()
        this.showOptionRankedCitiesAndKnights()
        this.content.style.width = '80%'

        const unranked4PTitleText: TranslationObject = {key: 'strings:homePage.matchmakingPopup.unranked4Player'}
        const unranked1v1TitleText: TranslationObject = {key: 'strings:homePage.matchmakingPopup.unranked1v1'}
        setElementInnerHTML(this.optionUnranked4PlayerTitle, unranked4PTitleText)
        setElementInnerHTML(this.optionUnranked1v1Title, unranked1v1TitleText)
    }

    private hideOptions() {
        this.removeOptionRanked1v1()
        this.removeOptionRankedBase()
        this.removeOptionRankedCitiesAndKnights()
        this.removeOptionUnranked4Player()
        this.removeOptionUnranked1Player()
        this.removeOptionBot()
        this.removeOptionBeginnerMode()
        this.removeOptionCreateAdvancedMode()
        this.removeOptionEasyBots()
        this.removeOptionMediumBots()
        this.removeOptionHardBots()
    }

    showSinglePlayerOptions() {
        setElementInnerHTML(this.popupTitle, {key: 'strings:homePage.ctas.singlePlayer'})
        this.hideOptions()
        this.showOptionBeginnerMode()
        this.showOptionBot()
        this.content.style.width = '40%'
    }

    showAllBotOptions() {
        setElementInnerHTML(this.popupTitle, {key: 'strings:homePage.ctas.playVsBots'})
        this.hideOptions()
        this.showOptionEasyBots()
        this.showOptionMediumBots()
        this.showOptionHardBots()
        this.content.style.width = '60%'
    }

    setMatchmakingOptionsHeader() {
        setElementInnerHTML(this.popupTitle, {key: 'strings:homePage.matchmakingPopup.selectGameType'})
    }

    setUnrankedOptionsStatusText(unrankedModeText: TranslationObject) {
        setElementInnerHTML(this.rankedStateUnranked1v1, unrankedModeText)
        setElementInnerHTML(this.rankedStateUnrankedBase, unrankedModeText)
    }

    hide() {
        this.container.style.display = 'none'
    }

    show() {
        this.container.style.display = 'block'
    }
}
